import React from "react";
import { SectionTitle } from "components/items";
import { BtnText } from "components/btns";
import makeTitle from "function/makeTitle.js";
// import logo_01 from "image/logo/logo_01.png";
// import logo_02 from "image/logo/logo_02.png";
// import logo_03 from "image/logo/logo_03.png";
import logo_04 from "image/logo/logo_04.png";
// import file_01 from "download/identity/20190831_CI_main.ai.zip";
// import file_02 from "download/identity/20190122_CI_mini.ai.zip";
// import file_03 from "download/identity/20190122_CI_typeface.ai.zip";
import file_04 from "download/identity/donggubat_factory.ai.zip";

const sectionTitle = [
	{
		text: "BRAND",
		color: "defualt",
		break: false,
	},
	{
		text: "IDENTITY",
		color: "main",
		break: true,
	},
];
const files = [
	{
		id: "file-04",
		name: "동구밭 팩토리 로고",
		fileName: "동구밭팩토리_로고",
		image: logo_04,
		download: file_04,
	},
];

const BrandIdentity = (props) => {
	const drawFiles = () => {
		return files.map((el) => {
			return (
				<li key={el.id} className="wrap-file">
					<p className="file-label">{el.name}</p>
					<img src={el.image} alt={el.name} />
					<BtnText to={el.download} download={el.name} text="다운로드" className="border" target="_blank" />
				</li>
			);
		});
	};

	const handleGuideClick = (e) => {
		e.preventDefault();
		alert(`가이드라인이 준비 중 입니다. `);
	};
	return (
		<section className={`BrandIdentity ${props.className}`}>
			<div className="section-header">
				<div className="con">
					<SectionTitle text={makeTitle(sectionTitle)} type="left" />
				</div>
			</div>

			<div className="section-contents">
				<div className="con">
					<div className="wrap-guide">
						<p className="guide-text">
							동구밭은 발달장애인과 함께 텃밭을 가꾸며 시작된 브랜드입니다. 텃밭을 가꾸는 것과 마찬가지로 동구밭 팩토리에서도 작물을 수확하듯 정성스럽게 고체 화장품을 만들고 있습니다. 동구밭
							팩토리에서 발달장애인과 비장애인, 사람과 사람이 이어져 시너지를 내는 모습을 형상화하며, 동구밭이라는 친근한 이름에 맞는 굴림체 타입페이스를 사용하고, 작물을 이용해 지속가능한 동구밭의
							가치를 표현한 브랜드 아이덴티티를 완성했습니다.
						</p>

						<div className="wrap-file">
							<p className="file-label">동구밭 로고를 사용하실 때 가이드입니다.</p>
							<BtnText to="/" text="브랜드 가이드 다운로드" className="border" onClick={handleGuideClick} />
						</div>
					</div>
					<div className="wrap-files">
						<ul className="files">{drawFiles()}</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default BrandIdentity;
